export enum TestIdEnum {
  NotificationBar = "notification-bar",
  NotificationBarClose = "notification-bar-close",
  NotificationBarLink = "notification-bar-link",

  TopBarTitle = "top-bar-title",

  Breadcrumbs = "breadcrumbs",

  SearchInput = "search-input",
  SearchButton = "search-button",

  MobileFiltersButton = "mobile-filters-button",
  MobileFiltersCount = "mobile-filters-count",

  AddShopButton = "add-shop-button",
  AddSuggestionButton = "add-suggestion-button",
  CloseModalButton = "close-modal-button",

  ProductsCount = "products-count",
  ProductsEmpty = "products-empty",
  ProductsSeoContent = "products-seo-content",
  ProductsSeoContentClose = "products-seo-content-close",
  ProductsTryAgain = "products-try-again",
  ProductsAllLoaded = "products-all-loaded",
  ProductCard = "product-card",
  ProductName = "product-name",
  ProductProducer = "product-producer",
  ProductShop = "product-shop",
  ProductCity = "product-city",
  ProductCaliber = "product-caliber",
  ProductPrice = "product-price",
  ProductAvailability = "product-availability",
  ProductLink = "product-link",

  ErrorMessage = "error-message",

  SorterButton = "sorter-button",
  SorterOption = "sorter-option",

  ShowMapButton = "show-map-button",

  CategoryBar = "category-bar",
  CategoryButtonPrefix = "category-button",

  Filters = "filters",
  FiltersSummary = "filters-summary",
  FiltersReset = "filters-reset",
  FiltersMultiPrefix = "filters-multi",
  FiltersInputPrefix = "filters-input",
  FiltersMultiClearPrefix = "filters-clear",
  FiltersMultiOptionPrefix = "filters-option",
  FiltersTagPrefix = "filters-tag",
  FiltersSingleOptionPrefix = "filters-single-option",
  FiltersSingleButtonPrefix = "filters-single-button",

  CloseButton = "close-button",

  TagPrefix = "tag",
  TagClosePrefix = "tag-close",
  // Footer
  Footer = "footer",
  FooterCategories = "footer-categories",
  FooterCities = "footer-cities",
  FooterProducers = "footer-producers",
  FooterProducerProducts = "footer-producer-products",

  MoveToTopButton = "move-to-top-button",

  MapWrapper = "map-wrapper",
  MapCloseButton = "map-close-button",
  MapPopupPrefix = "map-popup",
  MapPopupButtonPrefix = "map-popup-button",
  MapPopupShopNamePrefix = "map-popup-shop-name",
  MapPopupShopLinkPrefix = "map-popup-shop-link",
  MapPopupProductsCountPrefix = "map-popup-products-count",
  MapPopupAddressPrefix = "map-popup-address",
  MapPopupGoogleMapsLinkPrefix = "map-popup-google-maps-link",
}
